<template>
  <div class="formulario-registro-llamada" data-app>
    <titulo-seccion titulo="AGENDAR LLAMADA"></titulo-seccion>
    <div class="container container-agenda">
      <form @submit="GuardarLlamada">
        <div class="row-cols-12 w-100 ">
          <p class="parrafo-instrucciones parrafo-agenda mt-2">
            Indica la fecha y hora para realizar la llamada al prospecto.
            Considera que el prospecto recibirá un correo electrónico
            notificando la fecha y hora de la llamada.
          </p>
        </div>
        <div class="row row-cols-lg-12">
          <div class="col-lg-6 col-6">
            <label class="form-label label-formulario-solicitud label-agenda"
              >Fecha</label
            >
            <input-fecha
              idioma="es-MX"
              v-model="DatosLlamada.Fecha"
              :fechaMinima="new Date().toISOString()"
            ></input-fecha>
          </div>
          <div class="col-lg-6 col-6">
            <label class="form-label label-formulario-solicitud label-agenda"
              >Hora</label
            >
            <input-hora
              ref="inputHora"
              :deshabilitado="false"
              v-model="DatosLlamada.Hora"
              :horaMinima="horaMinima"
            ></input-hora>
          </div>
        </div>
        <div class="row row-cols-lg-12 d-flex justify-content-center mt-4">
          <div class="col-12">
            <button
              disabled
              v-if="loadingGuardar"
              class="btn w-100 boton-primario boton-agenda mb-3"
            >
              <v-progress-circular
                indeterminate
                size="30"
                color="white"
              ></v-progress-circular>
            </button>
            <button
              v-else
              type="submit"
              class="btn w-100 boton-primario boton-agenda mb-3"
            >
              Guardar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="js">

//Plugins
import axios from "axios";
import servicios from '../../../servicios/service.js';
//Mixins
import mixinRegistroEventos from "../Mixins/MixinRegistroEventos";
import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion";
//Componentes
import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import InputFecha from "../components/InputFecha.vue"
import InputHora from "../components/InputHora.vue";

//Variables
var rutaGuardarLlamada = "/api/Master/Llamada/GuardarLlamada";

export default {
  name: "RegistroLlamada",
  mixins: [mixinRegistroEventos, mixinSolicitudInscripcion],
  components: {
    TituloSeccion,
    InputFecha,
    InputHora
  },
  data() {
    return {
      menu2: false,
      loadingGuardar: false,
      date: null,
      catalogos: {
        Motivos: []
      },
      DatosLlamada: {
        MasterId: 1,
        ProspectoId:  this.$store.getters.prospectoId,
        Fecha:null,
        Hora:null,
        MotivoId: 0,
        CaminoId:null
      },
      horaMinima: null
    };
  },
  mounted() {
      const d = new Date();
      this.horaMinima =  d.getHours() + ":" + d.getMinutes();
  },
  watch: {
    'DatosLlamada.Fecha' : function (value) {
      this.DatosLlamada.Hora = null;
      this.$refs.inputHora.LimpiarTexto();

      var fechaElegida = new Date(value);
      var hoy = new Date();
      fechaElegida.setDate(fechaElegida.getDate() + 1);
      var fechaElegidaFormato = fechaElegida.toString().substring(4,15);

      if(fechaElegidaFormato != hoy.toString().substring(4,15))
        this.horaMinima = null;
      else
        this.horaMinima = hoy.getHours() + ":" + hoy.getMinutes();
    }
  },
  methods: {
    CamposLlenos(){
      if(this.DatosLlamada.Fecha == null || this.DatosLlamada.Hora == null){
        return false;
      } else {
        return true;
      }
    },
    GuardarLlamada : async function(e) {
      this.loadingGuardar = true;
      e.preventDefault();
      if(this.CamposLlenos()){
        const fechaLlamada = servicios.DarFormatoFecha(new Date( this.DatosLlamada.Fecha + "T" + this.DatosLlamada.Hora));
        const Llamada = {
          "MasterId": this.DatosLlamada.MasterId,
          "ProspectoId": this.DatosLlamada.ProspectoId,
          "Fecha" : fechaLlamada,
          "MotivoLlamadaId": this.DatosLlamada.MotivoId,
          "CaminoId": this.DatosLlamada.CaminoId
        }
        let respuesta = (await this.VerificarFechaEvento(fechaLlamada, Llamada)).data;
        if(respuesta == 1){
          this.loadingGuardar = false;
        }
      } else {
        this.loadingGuardar = false;
        this.AlertaEmbajadores("Por favor llene todos los campos necesarios para agendar la llamada.", true);
      }
    },
    RegistroEvento: function(Llamada) {
      this.loadingGuardar = true;
      axios.post(rutaGuardarLlamada, Llamada)
        .then(resp => {
          if (resp.data.estado === 0) {
            this.loadingGuardar = false;
            this.AlertaEmbajadores(resp.data.mensaje, true);
            // axios.defaults.headers.common["Authorization"] =
            //   "Bearer " + this.token;
            this.$router.push({
              name: "AdministracionDeProspectos"
            })
          } else if (resp.data.estado === 1) {
            this.loadingGuardar = false;
            this.AlertaEmbajadores(resp.data.mensaje, false);
          }
        })
         .catch(e => {
           this.loadingGuardar = false;
           this.ManejarExcepcion(e);
        });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";

.formulario-registro-llamada {
  flex-grow: 1;
}

.container-registro-llamada {
  width: 75%;
}

@media (max-width: 512px) {
  .container-registro-llamada {
    width: 90% !important;
  }
}
</style>
